// @flow
import { Icon } from 'semantic-ui-react';
import React from 'react';

export const CaretRightIcon = () => <Icon fitted={true} name="caret right" />;
